// extracted by mini-css-extract-plugin
export default {"membership_setting_section":"membership_setting_section__aa2e58c4","title_container":"title_container__aa2e58c4","btn_container":"btn_container__aa2e58c4","btn":"btn__aa2e58c4"};